"use client";

import { TKey } from "@/app/translations/TKey";
import { useT } from "@/app/translations/useT";
import { CallAnalysisOverviewTopic } from "@/app/types/call/CallAnalysisOverview";
import { topicColors, topicTypeKey } from "./AnalysisOverview.logic";
import styles from "./AnalysisOverview.module.css";
import TopicBars from "./TopicBars";

type Props = {
  title: string;
  topics: CallAnalysisOverviewTopic[];
  total: number;
};

export default function TopicChart(props: Props) {
  const T = useT();
  const { title, topics, total } = props;

  const rows = topics.map((topic) => {
    const typeKey = topicTypeKey(topic.type);

    return {
      label: topic.label,
      hint: String(topic.calls),
      colors: topicColors(topic.type),
      typeLabel: typeKey ? (T(typeKey) as string) : undefined,
    };
  });

  return (
    <div className={styles.card}>
      <div className={styles.cardHeader}>
        <span className={styles.cardTitle}>{title}</span>
        <span className={styles.cardHint}>
          {(T(TKey.CALL_OVERVIEW_OF_CALLS) as string).replace("{count}", String(total))}
        </span>
      </div>

      <TopicBars rows={rows} />
    </div>
  );
}
